import { CognitoIdentityClient } from '@aws-sdk/client-cognito-identity';
import { PutObjectCommand, S3Client } from '@aws-sdk/client-s3';
import { fromCognitoIdentity } from '@aws-sdk/credential-provider-cognito-identity';
import { useEffect, useState } from 'react';

import Cognito from 'Interface/Cognito';
import { useGetCognitoTokenQuery } from 'View/Service/Default/Cognito';

const useS3 = (): [S3Client | null, Cognito | undefined] => {
  const [s3, setS3] = useState<S3Client | null>(null);
  const { data: cognito, refetch } = useGetCognitoTokenQuery();

  const instanciateS3Client = (): void => {
    if (cognito) {
      setS3(
        new S3Client({
          region: cognito.region,
          credentials: fromCognitoIdentity({
            client: new CognitoIdentityClient({ region: cognito.region }),
            identityId: cognito.id,
            logins: { 'cognito-identity.amazonaws.com': cognito.token },
          }),
        })
      );
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => refetch(), []);
  useEffect(instanciateS3Client, [cognito]);

  return [s3, cognito];
};

export const useUpload = () => {
  const [s3, cognito] = useS3();

  const upload = async (path: string, file: File): Promise<string> => {
    if (s3) {
      const fileName = Math.floor(Math.random() * 10000000000);
      const extension = file.name.split('.').at(-1);
      const key = `${path}/${fileName}.${extension}`;
      const params = {
        Bucket: cognito?.bucket,
        Key: key,
        Body: file,
      };

      try {
        await s3.send(new PutObjectCommand(params));
      } catch (e) {
        console.log(e);
      }

      return `${cognito?.url}/${key}`;
    }

    return '';
  };

  return upload;
};
